// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__+6WNu","navigationHide":"navigation_navigationHide__SJgEc","underline":"navigation_underline__wKRl6"};